export const INITIAL_ADD_FOOD_MODAL_SESSION_STATE = Object.freeze({
  isVisible: false,
  sessionKey: 0,
});

export function reduceAddFoodModalSession(
  state = INITIAL_ADD_FOOD_MODAL_SESSION_STATE,
  action = {},
) {
  const currentState = state ?? INITIAL_ADD_FOOD_MODAL_SESSION_STATE;

  switch (action?.type) {
    case "open":
      return {
        isVisible: true,
        sessionKey: currentState.sessionKey + 1,
      };
    case "close":
      return currentState.isVisible
        ? {
            ...currentState,
            isVisible: false,
          }
        : currentState;
    default:
      return currentState;
  }
}
